import { List, Map, Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";
import { DateRecord } from "../../model/data/DateRecord";
import { TimespanRecord } from "../../model/data/TimespanRecord";
import { TextMetricsRecord } from "../textMetrics/TextMetricsRecord";
import { TextSizeRecord } from "../textMetrics/TextSizeRecord";
import { DateDisplayRecord } from "./DateDisplayRecord";

export const ItemDisplayRecord = Record({
  // Normal properties of Event
  id: null,
  type: null,
  displayId: null,
  initials: null,
  label: null,
  shortLabel: null,
  summary: null,
  color: null, // Always converted to Swatch Color by now
  colorId: null, // Original value in ItemRecord
  ongoing: false,
  hasOngoingDescendants: false,
  duration: TimespanRecord(),
  // References/Relationships with other things
  references: List([]),
  inverseReferences: List([]),
  super: null,
  isFiltered: false,
  children: List(),
  // Dependencies and Constraints
  blockingDependencies: List(),
  blockedByDependencies: List(),
  dateConstraints: List(),
  // Anniversary Info
  showAnniversary: false,
  anniversaryIcon: "markerOther",

  // Location URI: Only to be filled in for items of a category type (category = location)
  locationUri: null,

  // Display extensions
  startDate: DateDisplayRecord(),
  endDate: DateDisplayRecord(),
  preferredStartDate: DateRecord(),
  latestStartDate: null,
  earliestEndDate: null,
  preferredEndDate: DateDisplayRecord(),
  durationToEarliestEnd: null,
  preferredDuration: TimespanRecord(),
  drawPreferredEndDate: DateRecord(),
  isDateLocked: false,
  narrativePosition: List(),
  narrativeHasChildren: false,
  narrativeLabel: null,
  narrativeAutoLabel: null, // the manual or auto section type
  narrativeDisplayLabel: null, // the full string we will display
  narrativePathLabel: null, // the full string of all parents and this item
  sequenceIndex: null,
  nestedIndex: null,
  titleMetrics: TextMetricsRecord(),
  nestedTitleMetrics: TextMetricsRecord(),
  narrativeNestedTitleMetrics: TextMetricsRecord(),
  subwayTitleMetrics: TextMetricsRecord(),

  itemCardNestedTitleMetrics: TextMetricsRecord(),
  itemCardNarrativeNestedTitleMetrics: TextMetricsRecord(),
  itemCardNestedSummaryMetrics: TextMetricsRecord(),
  itemCardNarrativeNestedSummaryMetrics: TextMetricsRecord(),

  summaryMetrics: TextMetricsRecord(),
  dateTextSize: TextSizeRecord(),
  durationTextSize: TextSizeRecord(),
  narrativeTextSize: TextSizeRecord(),
  identifierSize: SizeRecord(),
  relatedItemsByType: List(),
  blockingIdentifiers: List(),
  blockedByIdentifiers: List(),
  itemCardSize: SizeRecord(),
  colorLabel: null,
  superColor: null,
  superLabel: null,
  superDepth: 0,
  excludedByFilter: false,
  index: 0,
  selected: false,
  isCompleted: false,
  propertyValues: Map(),
  tags: List(),

  image: null,
  imagePath: null,
  attachments: List(),
  links: List(),

  hasViolatedConstraints: false
});

const data = {
  objects: {
    startDate: "DateDisplayRecord",
    endDate: "DateDisplayRecord",
    preferredStartDate: `DateRecord`,
    preferredDuration: `TimespanRecord`,
    narrativePosition: "List",
    duration: "TimespanRecord",
    titleMetrics: "TextMetricsRecord",
    itemCardNestedTitleMetrics: "TextMetricsRecord",
    itemCardNarrativeNestedTitleMetrics: "TextMetricsRecord",
    summaryMetrics: "TextMetricsRecord",
    dateTextSize: "TextSizeRecord",
    durationTextSize: "TextSizeRecord",
    narrativeTextSize: "TextSizeRecord",
    identifierSize: "SizeRecord",
    itemCardSize: "SizeRecord",
    children: "List",
    references: "List",
    inverseReferences: "List",
    propertyValues: "Map",
    attachments: "List",
    links: "List"
  },
  collections: {}
};
createFromJS.registerCallback("ItemDisplayRecord", createFromJS.createNestedCallback(ItemDisplayRecord, data));
